import React from 'react';

export default ({ color }) => (
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38"><title>icon-problems</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2px" points="19 1 1 37 37 37 19 1"/><path fill={color} d="M18,25.88l-.79-12.45h3.7l-.79,12.45Zm-.6,5.31v-3h3.32v3Z"/></g></g></svg>
);
